import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const uuid = require('uuid');

const _ = {
    cloneDeep:  require('lodash/cloneDeep'),
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    isEqual:    require('lodash/isEqual'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
// const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');

import ErrorBox from '../common/ErrorBox';
import LoadingMainContent from '../loading/LoadingMainContent';


const propTypes = {
    doc: PropTypes.object.isRequired,
    courseHash: PropTypes.string.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
};

let MERGE_STATE = {
    START: 0,
    STICKERS: 1,
    COACH_SCRIPTS: 2,
    PHRASES: 3,
    END: 4,
};

function sameSrc(a,b) {
    if (a.src === b.src) {
        return true;
    }
    if (!a.src) {
        return !b.src ? true : false;
    }
    if (!b.src) {
        return false;
    }
    let a_src = a.src.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
    let b_src = b.src.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
    return (a_src === b_src);
}

class ImportCourseDataModal extends React.Component {
    constructor(props) {
        super(props);
        let actionId_getStateChannel = null;
        
        this.state = {
            channelStoreState: null, 
            actionId_getStateChannel: null,
            selected_course_id: 'none',
        };
        this.unsubscribes = [
            ShortCourseStore.listen(this.onStoreChange),
        ];
    }
    
    componentDidMount() {
        let channelStoreState = ShortCourseStore.getStateChannel(this.props.channelId);
        if (!channelStoreState.initialized) {
            let actionId_getStateChannel = uuid.v4();
            this.setState({actionId_getStateChannel},()=>{
                ShortCourseActions.getChannelShortCourses(actionId_getStateChannel, {channelId:this.props.channelId});
            });
        }
        else {
            this.setState({channelStoreState});
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onStoreChange=(storeState)=>{
        if (storeState.action) {
            if (storeState.action.id === this.state.actionId_getStateChannel) {
                let actionId_getStateChannel = null;
                let error = null;
                let channelStoreState = ShortCourseStore.getStateChannel(this.props.channelId);
                if (storeState.action.error) {
                    console.log("getStateChannel error",storeState.action.error);
                    error = storeState.action.error;
                }
                this.setState({actionId_getStateChannel, channelStoreState, error});
            }
            else if (storeState.action.id === this.state.actionId_getDoc) {
                this.setupMergeState(false);
            }
        }
    }
    
    getStickersToImport=(otherDoc)=>{
        let allImportStickers = otherDoc.client_content.coach_stickers || [];
        
        // remove duplicate and blank import stickers 
        let importStickers = [];
        _.forEach(allImportStickers,(entry)=>{
            if (!entry.src) {
                return;
            }
            let check = _.find(importStickers,(otherEntry)=>(sameSrc(entry,otherEntry)));
            if (!check) {
                importStickers.push(entry);
            }
            
        });
        
        let targetStickers = this.props.doc.client_content.coach_stickers || [];
        let stickersToAdd = [];

        _.forEach(importStickers,(entry)=>{
            let alreadyHaveSticker = _.find(targetStickers,(targetEntry)=>sameSrc(entry,targetEntry));
            if (!alreadyHaveSticker) {
                let addEntry = {...entry};
                let duplicateId = _.find(targetStickers,{id:entry.id});
                let duplicateName = _.find(targetStickers,{displayName:entry.displayName});

                if (duplicateId) {
                    addEntry.id ='sticker-' + uuid.v4();
                }
                if (duplicateName) {
                    let altDisplayName;
                    let i;
                    for (i=2; i<100; ++i) {
                        altDisplayName = addEntry.displayName + `(${i})`;
                        if (!_.find(targetStickers,{displayName:altDisplayName}) &&
                            !_.find(importStickers,{displayName:altDisplayName})) {
                            addEntry.displayName = altDisplayName;
                            break;
                        }
                    }
                }
                stickersToAdd.push(addEntry);
            }
        });

        return stickersToAdd;
    } // getStickersToImport
    
    getCoachScriptsToImport=(otherDoc)=>{
        let coachScriptsToImport = otherDoc.client_content.coach_scripts.slice();
        let richTextCount = otherDoc.client_content.rich_texts.length;
        return { coachScriptsToImport, richTextCount };
    } // getCoachScriptsToImport
    
    getPhraseSetsToImport=(otherDoc)=>{
        let phraseSetsToImport = [];
        let phraseSetReplaceCount = 0;
        if (!otherDoc.client_content.phraseData) {
            return { phraseSetsToImport, phraseSetReplaceCount };
        }
        let existingPhraseSets = this.props.doc.client_content.phraseData ? this.props.doc.client_content.phraseData.phraseSets : [];
        if (!existingPhraseSets) {
            phraseSetsToImport = otherDoc.client_content.phraseData.phraseSets;
            return { phraseSetsToImport, phraseSetReplaceCount }
        }

        // exclude phrase sets that are identical
        if (otherDoc.client_content.phraseData) {
            _.forEach(otherDoc.client_content.phraseData.phraseSets,(phraseSet)=>{
                let existingPhraseSet = _.find(existingPhraseSets,{variableSuffix:phraseSet.variableSuffix});
                if (existingPhraseSet) {
                    let p1 = { phrases: existingPhraseSet.phrases.slice().sort() };
                    let p2 = { phrases: phraseSet.phrases.slice().sort() };
                    if (_.isEqual(p1,p2)) {
                        return;
                    }
                }
                let setToAdd = { ...phraseSet }
                if (existingPhraseSet) {
                    // replace the existing phrase set
                    phraseSetReplaceCount++;
                }
                else {
                    // add new phrase set
                    let duplicateId = _.find(existingPhraseSets,{id:phraseSet.id});
                    if (duplicateId) {
                        setToAdd.id = 'phraseset-' + uuid.v4();
                    }
                }
                phraseSetsToImport.push(setToAdd);
            });
        }
        return { phraseSetsToImport, phraseSetReplaceCount };
    } // getPhraseSetsToImport
    
    onSelectOtherCourse=(e)=>{
        this.setState({selected_course_id:e.target.value},()=>{
            this.setupMergeState(true);
        });
    }
    
    setupMergeState=(canRequestDoc)=>{
        let selected_course_id = this.state.selected_course_id;
        const doc = ShortCourseStore.getShortCourseDoc(selected_course_id).doc;
        let actionId_getDoc = null;
        let mergeState = null;
        let error = null;
        if (!doc) {
            if (canRequestDoc) {
                actionId_getDoc = uuid.v4();
            }
            else {
                error = new Error("Failed to get doc to import");
            }
        }
        else {
            if (!doc.client_content.coach_scripts) {
                error = new Error("Specified doc is out of date and cannot be imported.");
            }
            else {
                let stickersToImport = this.getStickersToImport(doc);
                let { phraseSetsToImport, phraseSetReplaceCount } = this.getPhraseSetsToImport(doc);
                let { coachScriptsToImport, richTextCount } = this.getCoachScriptsToImport(doc);
                mergeState = {
                    replaceAll: true,
                    importStickers: true,
                    importPhrases: true,
                    importCoachScripts: true,
                    stickersToImport, // only those with new src values (or those used by imported coach scripts)
                    phraseSetsToImport, phraseSetReplaceCount, // some get replaced, others are added
                    coachScriptsToImport, richTextCount,
                };
            }
        }
        this.setState({doc, actionId_getDoc, mergeState, error},()=>{
            if (actionId_getDoc) {
                ShortCourseActions.getShortCourseWithDocAtVersion(actionId_getDoc, {
                    channelId: this.props.channelId,
                    shortCourseId: selected_course_id,
                    // shortCourseVersion: undefined,
                });
            }
        });
    }
    
    setMergeOption=(k,e)=>{
        let mergeState = { ...this.state.mergeState, [k]: e.target.checked};
        this.setState({mergeState});
    }
    
    renderOtherDocMerge=(otherDoc)=>{
        if (!otherDoc) {
            return;
        }
        const mergeState = this.state.mergeState;
        if (!mergeState) {
            return;
        }
        
         if (mergeState.done) {
             return (
                <div className="import-options">
                    <button className="btn btn-primary update-button" title={Strings['en'].short_course.modals.import_course_data.IMPORT_COMPLETE} onClick={this.props.closeHandler}>
                        {Strings['en'].short_course.modals.import_course_data.IMPORT_COMPLETE}
                    </button>
                </div>
            );
         }
        
        let phraseSetImportCount = mergeState.phraseSetsToImport.length;
        let phraseSetReplaceCount = mergeState.phraseSetReplaceCount;
        let phraseSetAddCount = phraseSetImportCount - phraseSetReplaceCount;
        let repCount = (phraseSetReplaceCount === 1) ? "one phrase set" : `${phraseSetReplaceCount} phrase sets`;
        let addCount = (phraseSetAddCount === 1) ? "one phrase set": `${phraseSetAddCount} phrase sets`;

        let phraseImportDetailText;
        if (!phraseSetImportCount) {
            phraseImportDetailText = "No phrase sets will be imported";
        }
        else if (phraseSetAddCount && phraseSetReplaceCount) {
            phraseImportDetailText = `${repCount} would be replaced and ${addCount} would be added.`;
        }
        else if (phraseSetReplaceCount) {
            phraseImportDetailText = `${repCount} would be replaced.`;
        }
        else {
            phraseImportDetailText = `${addCount} would be added.`;
        }
        
        return (
            <div className="import-options">
                <span className="option-row">
                    <input type="checkbox" onChange={this.setMergeOption.bind(this,'replaceAll')} 
                        checked={mergeState.replaceAll ? true : false}/>
                    <label>{Strings['en'].short_course.modals.import_course_data.REPLACE_ALL}</label>
                </span>
                { mergeState.replaceAll ? null : 
                <div>
                    <span className="option-row">
                        <input type="checkbox" onChange={this.setMergeOption.bind(this,'importCoachScripts')} 
                            checked={mergeState.importCoachScripts ? true : false}/>
                        <label>{Strings['en'].short_course.modals.import_course_data.IMPORT_COACH_SCRIPTS}</label>
                        <div className="details">{`${mergeState.coachScriptsToImport.length} coach scripts would be replaced along with ${mergeState.richTextCount} rich_texts`}</div>
                    </span>
                    <span className="option-row">
                        <input type="checkbox" onChange={this.setMergeOption.bind(this,'importStickers')} 
                            checked={mergeState.importStickers ? true : false}/>
                        <label>{Strings['en'].short_course.modals.import_course_data.IMPORT_STICKERS}</label>
                        <div className="details">{`${mergeState.stickersToImport.length} coach stickers would be added`}</div>
                    </span>
                    <span className="option-row">
                        <input type="checkbox" onChange={this.setMergeOption.bind(this,'importPhrases')} 
                            checked={mergeState.importPhrases ? true : false}/>
                        <label>{Strings['en'].short_course.modals.import_course_data.IMPORT_PHRASES}</label>
                        <div className="details">{phraseImportDetailText}</div>
                    </span>
                </div>
                }
                <button className="btn btn-primary update-button" title={Strings['en'].short_course.modals.import_course_data.START_IMPORT} onClick={this.doImport.bind(this,otherDoc)}>
                    {Strings['en'].short_course.modals.import_course_data.START_IMPORT}
                </button>
            </div>
        );
    }
    
    doImport=(otherDoc)=>{
        const mergeState = this.state.mergeState;
        if (!mergeState || mergeState.done) {
            return;
        }
        let changes = {}; // changes to client_content
        if (mergeState.replaceAll) {
            if (otherDoc.client_content.coach_scripts) {
                changes.coach_scripts = otherDoc.client_content.coach_scripts;
            }
            if (otherDoc.client_content.rich_texts) {
                changes.rich_texts = otherDoc.client_content.rich_texts;
            }
            if (otherDoc.client_content.coach_stickers) {
                changes.coach_stickers = otherDoc.client_content.coach_stickers;
            }
            if (otherDoc.client_content.phraseData) {
                changes.phraseData = otherDoc.client_content.phraseData;
            }
        }
        else {
            let stickersToImport = mergeState.stickersToImport;
            let phraseSetsToImport = mergeState.phraseSetsToImport;
            let coachScriptsToImport = mergeState.coachScriptsToImport;
            
            let coach_scripts = null;
            let rich_texts = null;
            let coach_stickers = null;
            let phraseData = null;
            
            if (mergeState.importStickers) {
                coach_stickers = this.props.doc.client_content.coach_stickers.slice();
                coach_stickers = coach_stickers.concat(stickersToImport);
            }
            
            if (mergeState.importPhrases && phraseSetsToImport && phraseSetsToImport.length) {
                phraseData = this.props.doc.client_content.phraseData;
                if (!phraseData) {
                    phraseData = {
                        phraseSets: phraseSetsToImport
                    }
                }
                else {
                    let newPhraseSets = [];
                    _.forEach(phraseData.phraseSets,(phraseSet)=>{
                        let f = _.find(phraseData.phraseSets,{variableSuffix: phraseSet.variableSuffix});
                        if (f) {
                            newPhraseSets.push({
                                ...f, phrases: phraseSet.phrases // replace phrases
                            });
                        }
                        else {
                            newPhraseSets.push(phraseSet); // add new set
                        }
                    });
                    phraseData.phraseSets = newPhraseSets;
                }
            }

            if (mergeState.importCoachScripts) {
                coach_scripts = [];
                rich_texts = otherDoc.client_content.rich_texts;
                _.forEach(coachScriptsToImport,(scriptEntry)=>{
                    let adjustedScriptEntry = _.cloneDeep(scriptEntry);
                    _.forEach(adjustedScriptEntry.actions,(actionEntry)=>{
                        if (actionEntry.coach_sticker_id) {
                            let sticker = _.find(otherDoc.client_content.coach_stickers,{id:actionEntry.coach_sticker_id});
                            if (sticker) {
                                let i_stick = _.find(coach_stickers,(s)=>(sameSrc(sticker,s)));
                                let t_stick = _.find(this.props.doc.client_content.coach_stickers,(s)=>(sameSrc(sticker,s)));
                                if (i_stick) {
                                    actionEntry.coach_sticker_id = i_stick.id;
                                }
                                else if (t_stick) {
                                    actionEntry.coach_sticker_id = t_stick.id;
                                }
                                else {
                                    console.log("coach script entry imported without sticker", sticker, actionEntry);
                                }
                            }
                            else {
                                console.log("ignoring invalid coach_sticker_id for action",actionEntry);
                            }
                        }
    
                    });
                    coach_scripts.push(adjustedScriptEntry);
                });
            }
            if (coach_scripts) {
                changes.coach_scripts = coach_scripts;
            }
            if (rich_texts) {
                changes.rich_texts = rich_texts;
            }
            if (coach_stickers) {
                changes.coach_stickers = coach_stickers;
            }
            if (phraseData) {
                changes.phraseData = phraseData;
            }
        }
        ShortCourseEditorActions.importClientContent(uuid.v4(),changes);
        this.setState({mergeState: {...mergeState, done:true }});
    }
    
    render() {
        let shortCourses;
        const loading = (this.state.actionId_getDoc || this.state.actionId_getStateChannel || !this.state.channelStoreState);
        let doc = this.state.selected_course_id ? this.state.doc : null;
        if (this.state.channelStoreState && this.state.channelStoreState.initialized) {
            shortCourses = [];
            _.forEach(this.state.channelStoreState.shortCourses,(arr/*,projectId*/)=>{
                let excluding_arr = _.filter(arr,(arr)=>(arr.hash !== this.props.courseHash));
                if (excluding_arr.length) {
                    shortCourses = shortCourses.concat(excluding_arr);
                }
            });
        }

        return (
            <Modal
                dialogClassName="import-course-data-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
                aria-labelledby="import-course-data-title"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.props.closeHandler}>
                    <Modal.Title id="import-course-data-title">{Strings['en'].short_course.modals.import_course_data.MODAL_HEADER}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { loading ? 
                    <LoadingMainContent />
                    :
                    <div className="import-course-data-body">
                        {shortCourses.length ? 
                        <div className="option-row">
                            <label>{Strings['en'].short_course.modals.import_course_data.SELECT_OTHER_COURSE  + ':'}</label>
                            <select value={this.state.selected_course_id} onChange={this.onSelectOtherCourse}>
                                <option value={'none'} disabled>{'Select...'}</option>
                        { _.map(shortCourses,(entry,index)=>{
                            return (
                                <option key={index} value={entry.id}>
                                    {entry.title}
                                </option>
                            )
                        })}
                            </select>
                        </div>
                        :
                        <div className="error-text">
                         { Strings['en'].short_course.modals.import_course_data.NO_OTHER_COURSES}
                        </div>
                        }
                    </div>
                    }
                    { this.renderOtherDocMerge(doc) }
                    <ErrorBox error={this.state.error}/>
                </Modal.Body>
                <Modal.Footer>
                    {/*
                    <button className="btn btn-primary update-button" title={Strings['en'].common.UPDATE} disabled={false} onClick={this.save}>
                        {Strings['en'].common.UPDATE}
                    </button>
                    */ }
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // ImportCourseDataModal

ImportCourseDataModal.propTypes = propTypes;
ImportCourseDataModal.defaultProps = defaultProps;

export default ImportCourseDataModal;